module.exports = __webpack_public_path__ + "img/auburn.254be995.svg";